/*
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import React, {Fragment, useEffect, useRef, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {ArrowUturnLeftIcon, CheckCircleIcon, ExclamationTriangleIcon, XMarkIcon} from '@heroicons/react/24/outline'
import {getVenueSession} from "../../requests/AppSession";
import {useNavigate} from "react-router-dom";
import LoginError from "../login/LoginError";
import CircularProgress from "@mui/material/CircularProgress";
import {ArrowPathIcon, UsersIcon} from "@heroicons/react/20/solid";
import soundError from "./sound/error.mp3";
import {DancerListSkeleton, TierGridSkeleton} from "./VTSkeletons";
import sound from "./sound/cash2.mp3";
import VTDancePayQRReader from "./VTDancePayQRReader";
import {useAuth0} from "@auth0/auth0-react";
import {findDancerDances, revertDance} from "../requests/AppRequestDance";
import {findVenueDancers} from "../requests/AppRequestDancer";
import {sell} from "../requests/AppRequestVenue";


let virtualTipzPayPackages = null;

// ,
// {
//     "id": "5f5ef3cf-4019-4a5b-b3f0-b71856bc92f2",
//     "name": "Drink",
//     "sellType": "DRINK",
//     "description": "",
//     "features": null
// }

export default function VTDancePay() {
    let navigate = useNavigate();

    const {isLoading, getAccessTokenSilently} = useAuth0();

    const [open, setOpen] = useState(false);
    const [revertOpen, setRevertOpen] = useState(false);

    const [show, setShow] = useState(false);

    const [showError, setShowError] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(null);

    const [isQRReader, setIsQRReader] = useState(true);
    const [showQRReader, setShowQRReader] = useState(false);

    const [openConfirmRevert, setConfirmRevertOpen] = useState(false);
    const cancelButtonRef = useRef(null);

    const [selectedSize, setSelectedSize] = useState(null);
    const [userCode, setUserCode] = useState(null);
    const [venueId, setVenueId] = React.useState(null);
    const [venueName, setVenueName] = React.useState(null);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(null);

    const [privateDancePayFeatureFlag, setPrivateDancePayFeatureFlag] = React.useState(null);
    const [dancePayFeatureFlag, setDancePayFeatureFlag] = React.useState(null);

    const [adminCode, setAdminCode] = useState("10756845868867801");
    const [adminCodeFeatureFlag, setAdminCodeFeatureFlag] = React.useState(false);

    const [revertAmount, setRevertAmount] = React.useState(null);

    const [people, setPeople] = React.useState(null);
    const [peopleFiltered, setPeopleFiltered] = React.useState(null);
    const [selectedDancerId, setSelectedDancerId] = React.useState(null);
    const [selectedDancerCode, setSelectedDancerCode] = React.useState(null);
    const [selectedDancerName, setSelectedDancerName] = React.useState(null);
    const [virtualTipz, setVirtualTipz] = useState(null);

    const [dancerDances, setDancerDances] = React.useState(null);
    const [selectedDanceId, setSelectedDanceId] = React.useState(null);

    useEffect(() => {
        getVenueSession().then(venueSession => {
            if (venueSession && venueSession.id !== "null") {
                setVenueId(venueSession.venueId);
                setVenueName(venueSession.venueName);
            } else {
                navigate('/login/mobile', {replace: true});
            }

            if (!venueSession.dancePayFeatureFlag && !venueSession.privateDancePayFeatureFlag) {
                navigate('/login/mobile', {replace: true});
            }

            if (venueSession) {
                setPrivateDancePayFeatureFlag(venueSession.privateDancePayFeatureFlag);
                setDancePayFeatureFlag(venueSession.dancePayFeatureFlag);
            } else {
                setPrivateDancePayFeatureFlag(false);
                setDancePayFeatureFlag(false);
            }
        })
        return function cleanup() {

        };
    }, []);

    useEffect(() => {

        if (privateDancePayFeatureFlag && dancePayFeatureFlag) {
            virtualTipzPayPackages = [
                {
                    "id": "d0769cd1-4a70-418b-8dce-df7cfbba5274",
                    "name": "Private Dance",
                    "sellType": "PRIVATE_DANCE",
                    "description": "",
                    "features": null,
                    "customCost": true
                },
                {
                    "id": "2d805e66-5b66-4bad-b097-7fa6a1e2b9a1",
                    "name": "Lap Dance",
                    "sellType": "DANCE",
                    "description": "",
                    "features": null,
                    "customCost": true
                }];
        } else if (privateDancePayFeatureFlag) {
            virtualTipzPayPackages = [
                {
                    "id": "d0769cd1-4a70-418b-8dce-df7cfbba5274",
                    "name": "Private Dance",
                    "sellType": "PRIVATE_DANCE",
                    "description": "",
                    "features": null,
                    "customCost": true
                }];
        } else if (dancePayFeatureFlag) {
            virtualTipzPayPackages = [
                {
                    "id": "2d805e66-5b66-4bad-b097-7fa6a1e2b9a1",
                    "name": "Lap Dance",
                    "sellType": "DANCE",
                    "description": "",
                    "features": null,
                    "customCost": true
                }];
        } else {
            virtualTipzPayPackages = [];
        }

        return function cleanup() {

        };
    }, [privateDancePayFeatureFlag, dancePayFeatureFlag]);

    const getDancerDancesSuccess = async responseJson => {
        if (
            responseJson
        ) {
            setDancerDances(responseJson);
        } else {
            setErrorMessage("Error accessing dancer dances, please refresh and verify Internet Connection.");
        }
    };

    const getDancerDancesError = forceLogout => {
        setErrorMessage("Error accessing dancer dances, please refresh and verify Internet Connection.");
    };

    useEffect(() => {
        if (selectedDancerId !== null && revertOpen) {
            findDancerDances(venueId, selectedDancerId, getDancerDancesSuccess, getDancerDancesError, getAccessTokenSilently);
        }
        return function cleanup() {

        };
    }, [selectedDancerId]);

    const getVenueDancersSuccess = async responseJson => {
        if (
            responseJson
        ) {
            setPeople(responseJson.dancers);
            setPeopleFiltered(responseJson.dancers);
        } else {
            setErrorMessage("Error getting dancer list, please refresh and verify Internet Connection.");
        }
    };

    const getVenueDancersError = forceLogout => {
        setErrorMessage("Error getting dancer list, please refresh and verify Internet Connection.");
    };

    useEffect(() => {
        if (!isLoading && venueId !== null) {
            findVenueDancers(venueId, getVenueDancersSuccess, getVenueDancersError, getAccessTokenSilently);
        }
        return function cleanup() {

        };
    }, [isLoading, venueId]);

    const submitSuccess = async responseJson => {
        setIsSubmitting(false);
        console.log(responseJson);
        if (
            responseJson &&
            responseJson.vtLeft >= 0
        ) {
            // setAdminCode(null);
            setShow(true);
            setUserCode(null);
            setRevertAmount(null);
            setSelectedSize(null);

            setPeopleFiltered(people);
            setSelectedDancerId(null);
            setSelectedDancerCode(null);
            setSelectedDancerName(null);
            setErrorMessage(null);

            setVirtualTipz(null);

            setDancerDances(null);
            setSelectedDanceId(null);

            setOpen(false);
            setRevertOpen(false);
            setShowQRReader(false);

            setTimeout(() => {
                setShow(false);
            }, 5000);
            await new Audio(sound).play();

        } else if (responseJson.error) {
            setErrorMessage(responseJson.message);
            setShowError(true);
            setShowErrorMessage("Failed to sell Dance, " + responseJson.message + "!");
            setShowQRReader(false);
            setTimeout(() => {
                setShowError(false);
            }, 10000);
            await new Audio(soundError).play();
        } else {
            setErrorMessage("There was a problem selling the Dance. Please verify User Code / QR is correct, that a dancer is selected, and that VirtualTipz amount is greater than 0.");
            setShowError(true);
            setShowErrorMessage("Failed to sale Dance. Please verify User Code / QR is correct and that a dancer is selected.");
            setShowQRReader(false);
            setTimeout(() => {
                setShowError(false);
            }, 10000);
            await new Audio(soundError).play();
        }
    };

    const submitError = forceLogout => {
        setIsSubmitting(false);
        setErrorMessage("There was a problem selling the Dance. Please verify User Code / QR is correct, that a dancer is selected, and that VirtualTipz amount is greater than 0.");
        setShowError(true);
        setShowErrorMessage("Failed to sale Dance. Please verify User Code / QR is correct and that a dancer is selected.");
        setShowQRReader(false);
        setTimeout(() => {
            setShowError(false);
        }, 10000);
        new Audio(soundError).play();
    };

    const submitRevertSuccess = async responseJson => {
        setIsSubmitting(false);
        setConfirmRevertOpen(false);
        console.log(responseJson);
        if (
            responseJson &&
            responseJson.vtLeft >= 0
        ) {
            // setAdminCode(null);
            setUserCode(null);
            setRevertAmount(null);
            setSelectedSize(null);

            setPeopleFiltered(people);
            setSelectedDancerId(null);
            setSelectedDancerCode(null);
            setSelectedDancerName(null);
            setErrorMessage(null);

            setVirtualTipz(null);

            setDancerDances(null);
            setSelectedDanceId(null);

            setOpen(false);
            setRevertOpen(false);
        } else {
            setErrorMessage("There was a problem reverting the Dance. Please verify Internet Connection and try again.");
        }
    };

    const submitRevertError = forceLogout => {
        setIsSubmitting(false);
        setConfirmRevertOpen(false);
        setErrorMessage("There was a problem reverting the Dance. Please verify Internet Connection and try again.");
    };

    const submitSellDance = (selectedSize, userCode) => {
        if (!userCode || userCode.trim() === "" || !adminCode || adminCode.trim() === "" || !selectedDancerId || selectedDancerId.trim() === "" || !virtualTipz || isNaN(virtualTipz)) {
            setErrorMessage("There was a problem selling the Dance. Please verify User Code / QR is correct, that a dancer is selected, and that VirtualTipz amount is greater than 0.");
            setShowError(true);
            setShowErrorMessage("Failed to sale Dance. Please verify User Code / QR is correct and that a dancer is selected.");
            setTimeout(() => {
                setShowError(false);
            }, 5000);
            new Audio(soundError).play();
            return;
        }
        setErrorMessage(null);
        setIsSubmitting(true);
        sell(venueId, userCode, adminCode, virtualTipz, selectedSize.sellType, selectedDancerCode, selectedDancerId, submitSuccess, submitError, getAccessTokenSilently);
    };

    const closeQRReader = () => {
        setSelectedSize(null);
        // setAdminCode(null);
        setUserCode(null);
        setRevertAmount(null);
        setPeopleFiltered(people);
        setSelectedDancerId(null);
        setSelectedDancerCode(null);
        setSelectedDancerName(null);
        setErrorMessage(null);

        setVirtualTipz(null);

        setDancerDances(null);
        setSelectedDanceId(null);

        setOpen(false);
        setShowQRReader(false);
    };

    return (
        <>
            {
                showQRReader ?
                    <VTDancePayQRReader setIsQRReader={setIsQRReader} selectedDancerName={selectedDancerName}
                                        submitVT={submitSellDance} selectedSize={selectedSize}
                                        sellName={selectedSize.name} virtualTipz={virtualTipz}
                                        setShowQRReader={closeQRReader}/> :

                    <>
                        <div className="bg-white dark:bg-gray-900">

                            {/* Pricing with virtualTipzPayPackages */}
                            <div className="bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-800">
                                <div className="mx-auto max-w-7xl px-4 pt-12 sm:px-6 lg:px-8">
                                    <div className="sm:align-center sm:flex sm:flex-col">
                                        <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-gray-100 text-center sm:text-5xl">Sell
                                            <span
                                                className="text-pink-400"> Dance</span></h1>
                                    </div>
                                    {virtualTipzPayPackages === null && <TierGridSkeleton/>}
                                    <div
                                        className="mt-12 space-y-4 sm:mt-16 sm:grid sm:grid-cols-2 sm:gap-6 sm:space-y-0 lg:mx-auto lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-4">
                                        {virtualTipzPayPackages && virtualTipzPayPackages.map((tier) => (
                                            <div key={tier.id}
                                                 className="divide-y divide-gray-200 dark:divide-gray-700 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
                                                <div className="p-6">
                                                    <h2 className="text-lg font-medium leading-6 text-gray-900 dark:text-gray-100">{tier.name}</h2>
                                                    <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">{tier.description}</p>
                                                    <p className="mt-8">
                                                        <span
                                                            className="text-4xl font-bold tracking-tight text-white">{'.'}</span>{' '}
                                                        {/*<span className="text-base font-medium text-gray-500">/mo</span>*/}
                                                    </p>
                                                    <button
                                                        name={tier.id}
                                                        className="mt-8 block w-full rounded-md border border-transparent bg-pink-600 py-2 text-center text-sm font-semibold text-white hover:bg-pink-700"
                                                        onClick={(event) => {
                                                            setSelectedSize(virtualTipzPayPackages.find(t => t.id === event.target.name));
                                                            setOpen(true);
                                                            setErrorMessage(null);
                                                        }}
                                                    >
                                                        Sell {tier.name}
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {virtualTipzPayPackages && <div className="mx-auto mt-10 mb-6 w-full max-w-xs">
                                        <div className="flex items-center gap-3">
                                            <div className="h-px flex-1 bg-gray-200 dark:bg-gray-700"/>
                                            <span className="text-xs font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">or</span>
                                            <div className="h-px flex-1 bg-gray-200 dark:bg-gray-700"/>
                                        </div>
                                        <button
                                            className="mt-4 flex w-full items-center justify-center gap-2 rounded-lg bg-white dark:bg-gray-800 py-3 text-sm font-semibold text-red-700 ring-1 ring-inset ring-red-300 transition hover:bg-red-50 active:bg-red-100"
                                            onClick={(event) => {
                                                setRevertOpen(true);
                                            }}
                                        >
                                            <ArrowUturnLeftIcon className="h-5 w-5" aria-hidden="true"/>
                                            Revert Dance
                                        </button>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </>
            }
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <div className="fixed inset-0"/>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                        <div
                                            className="flex h-full flex-col divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800 shadow-xl">
                                            <div className="h-0 flex-1 overflow-y-auto">
                                                <div className="bg-pink-700 px-4 py-6 sm:px-6">
                                                    <div className="flex items-center justify-between">
                                                        <Dialog.Title
                                                            className="text-base font-semibold leading-6 text-white">
                                                            {selectedSize && selectedSize.name}
                                                        </Dialog.Title>
                                                        <div className="ml-3 flex h-7 items-center">
                                                            <button
                                                                type="button"
                                                                className="rounded-md bg-pink-700 text-pink-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                                onClick={() => {
                                                                    setSelectedSize(null);
                                                                    // setAdminCode(null);
                                                                    setUserCode(null);
                                                                    setRevertAmount(null);
                                                                    setPeopleFiltered(people);
                                                                    setSelectedDancerId(null);
                                                                    setSelectedDancerCode(null);
                                                                    setSelectedDancerName(null);
                                                                    setErrorMessage(null);

                                                                    setVirtualTipz(null);

                                                                    setDancerDances(null);
                                                                    setSelectedDanceId(null);

                                                                    setOpen(false);
                                                                    setShowQRReader(false);
                                                                }}
                                                            >
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex flex-1 flex-col justify-between">
                                                    <div className="divide-y divide-gray-200 dark:divide-gray-700 px-4 sm:px-6">
                                                        {/*<div className="pb-2 pt-4">*/}
                                                        {/*    <div className="flex text-sm">*/}
                                                        {/*        <div*/}
                                                        {/*            className="group inline-flex items-center font-medium text-pink-600 hover:text-pink-900"*/}
                                                        {/*        >*/}
                                                        {/*<LinkIcon*/}
                                                        {/*    className="h-5 w-5 text-pink-500 group-hover:text-pink-900"*/}
                                                        {/*    aria-hidden="true"*/}
                                                        {/*/>*/}
                                                        {/*<span*/}
                                                        {/*    className="ml-2">{selectedSize && selectedSize.virtualTips} VirtualTipz</span>*/}
                                                        {/*<span*/}
                                                        {/*    className="ml-2">${selectedSize && selectedSize.price}</span>*/}
                                                        {/*        </div>*/}
                                                        {/*    </div>*/}
                                                        {/*    <div className="mt-4 flex text-sm">*/}
                                                        {/*    </div>*/}
                                                        {/*</div>*/}
                                                        <div className="space-y-6 pb-5 pt-6">
                                                            {errorMessage && <LoginError errorMessage={errorMessage}/>}
                                                            {!isQRReader && <div>
                                                                <label
                                                                    htmlFor="project-name"
                                                                    className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
                                                                >
                                                                    User Code
                                                                </label>
                                                                <div className="mt-2">
                                                                    <input
                                                                        type="text"
                                                                        name="userCode"
                                                                        value={userCode ?? ""}
                                                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 dark:bg-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                                                        onChange={(event) => {
                                                                            let uc = event.target.value;
                                                                            if (uc) {
                                                                                uc = uc.toUpperCase();
                                                                            }
                                                                            setUserCode(uc);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>}
                                                            <div>
                                                                <label
                                                                    htmlFor="project-name"
                                                                    className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
                                                                >
                                                                    VirtualTipz Cost
                                                                </label>

                                                                <div className="relative mt-2 rounded-md shadow-sm">

                                                                    <input
                                                                        type="number"
                                                                        name="virtualTipz"
                                                                        value={virtualTipz}
                                                                        className="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 dark:text-gray-100 dark:bg-gray-800 ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                                                        placeholder="0"
                                                                        aria-describedby="price-currency"
                                                                        onChange={(event) => {
                                                                            setVirtualTipz(event.target.value);
                                                                        }}
                                                                    />
                                                                    <div
                                                                        className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          <span className="text-gray-500 dark:text-gray-400 sm:text-sm" id="price-currency">
            VT
          </span>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            {selectedDancerId ? <div>
                                                                    <label
                                                                        htmlFor="project-name"
                                                                        className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
                                                                    >
                                                                        Choose Dancer
                                                                    </label>

                                                                    <span
                                                                        className="inline-flex mt-1 items-center rounded-md bg-pink-50 dark:bg-pink-950/40 px-2 py-1 text-sm font-bold text-gray-900 dark:text-pink-200 ring-1 ring-inset ring-pink-700/10 dark:ring-pink-800">
                                                                    {selectedDancerName}
                                                            </span>

                                                                    <div className="text-sm">
                                                                        <button
                                                                            className="font-medium mt-1 text-pink-500 cursor-pointer hover:text-pink-800"
                                                                            onClick={() => {
                                                                                setSelectedDancerId(null);
                                                                                setSelectedDancerCode(null);
                                                                                setSelectedDancerName(null);

                                                                                setDancerDances(null);
                                                                                setSelectedDanceId(null);

                                                                            }}
                                                                        >
                                                                            Choose a different dancer.
                                                                        </button>
                                                                    </div>

                                                                </div> :
                                                                <div>
                                                                    <label
                                                                        htmlFor="project-name"
                                                                        className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
                                                                    >
                                                                        Choose Dancer
                                                                    </label>
                                                                    <div className="relative mt-2 rounded-md shadow-sm">
                                                                        <div
                                                                            className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                                                            <UsersIcon className="h-5 w-5 text-gray-400 dark:text-gray-500"
                                                                                       aria-hidden="true"/>
                                                                        </div>
                                                                        <input
                                                                            type="text"
                                                                            name="search"
                                                                            className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 dark:text-gray-100 dark:bg-gray-800 ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                                                            placeholder="Search"
                                                                            onChange={(event) => {
                                                                                if (event.target.value && event.target.value.length > 0) {
                                                                                    let filteredPeople = people.filter(function (dancer) {
                                                                                        return dancer.name.substring(0, event.target.value.length).toLowerCase() === event.target.value.toLowerCase();
                                                                                    });
                                                                                    setPeopleFiltered(filteredPeople);
                                                                                } else {
                                                                                    setPeopleFiltered(people);
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="mt-6 flow-root">
                                                                        {!people && <DancerListSkeleton/>}
                                                                        <ul role="list"
                                                                            className="divide-y divide-gray-200 dark:divide-gray-700">
                                                                            {people && people.length === 0 &&
                                                                                <h3 className="mx-6">No Dancers are
                                                                                    setup
                                                                                    for this Venue.</h3>}
                                                                            {peopleFiltered && peopleFiltered.map((person) => (
                                                                                <li key={person.id}
                                                                                    className={selectedDancerId === person.id ? "py-4 bg-red-200" : "py-4"}>
                                                                                    <div
                                                                                        className="flex items-center space-x-4">
                                                                                        <div className="flex-shrink-0">
                                                                                            {/*<img className="h-8 w-8 rounded-full" src={person.imageUrl} alt="" />*/}
                                                                                        </div>
                                                                                        <div className="min-w-0 flex-1">
                                                                                            {selectedDancerId === person.id ?
                                                                                                <>
                                                                                                    <p className="truncate text-l font-bold text-gray-900 dark:text-gray-100">{person.name}</p>
                                                                                                    {/*<p className="truncate text-sm font-bold text-gray-500">ON STAGE</p>*/}
                                                                                                </>
                                                                                                :
                                                                                                <p className="truncate text-sm font-medium text-gray-900 dark:text-gray-100">{person.name}</p>
                                                                                            }
                                                                                        </div>
                                                                                        {selectedDancerId !== person.id &&
                                                                                            <div>
                                                                                                <button
                                                                                                    //disabled={isSwitchingGirls}
                                                                                                    className="inline-flex items-center rounded-full bg-white dark:bg-gray-800 px-2.5 py-1 text-xs font-semibold text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800"
                                                                                                    onClick={() => {
                                                                                                        //setIsSwitchingGirls(true);
                                                                                                        //switchGirl(venueId, person.id, switchGirlSuccess, switchGirlError);
                                                                                                        setSelectedDancerId(person.id);
                                                                                                        setSelectedDancerCode(person.dancerCode);
                                                                                                        setSelectedDancerName(person.name);

                                                                                                        setDancerDances(null);
                                                                                                        setSelectedDanceId(null);

                                                                                                        if (isQRReader) {
                                                                                                            setShowQRReader(true);
                                                                                                            setOpen(false);
                                                                                                        }
                                                                                                    }}
                                                                                                >
                                                                                                    Choose
                                                                                                </button>
                                                                                            </div>}
                                                                                    </div>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {adminCodeFeatureFlag && <div>
                                                                <label
                                                                    htmlFor="project-name"
                                                                    className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
                                                                >
                                                                    Admin Code
                                                                </label>
                                                                <div className="mt-2">
                                                                    <input
                                                                        type="text"
                                                                        name="adminCode"
                                                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 dark:bg-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                                                        onChange={(event) => {
                                                                            setAdminCode(event.target.value);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white dark:bg-gray-800 px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800"
                                                    onClick={() => {
                                                        setSelectedSize(null);
                                                        // setAdminCode(null);
                                                        setUserCode(null);
                                                        setRevertAmount(null);
                                                        setPeopleFiltered(people);
                                                        setSelectedDancerId(null);
                                                        setSelectedDancerCode(null);
                                                        setSelectedDancerName(null);
                                                        setErrorMessage(null);

                                                        setVirtualTipz(null);

                                                        setDancerDances(null);
                                                        setSelectedDanceId(null);

                                                        setOpen(false);
                                                        setShowQRReader(false);
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                                {!isQRReader && <button
                                                    disabled={isSubmitting}
                                                    className="ml-4 inline-flex justify-center rounded-md bg-pink-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                                                    onClick={() => {
                                                        if (!userCode || userCode.trim() === "" || !adminCode || adminCode.trim() === "" || !selectedDancerId || selectedDancerId.trim() === "" || !virtualTipz || isNaN(virtualTipz)) {
                                                            setErrorMessage("There was a problem selling the Dance. Please verify User Code / QR is correct, that a dancer is selected, and that VirtualTipz amount is greater than 0.");
                                                            return;
                                                        }
                                                        submitSellDance(selectedSize, userCode);
                                                    }}
                                                >
                                                    Sell Dance {isSubmitting &&
                                                    <CircularProgress color="inherit" size={20}/>}
                                                </button>}
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

            <Transition.Root show={revertOpen} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setRevertOpen}>
                    <div className="fixed inset-0"/>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                        <div
                                            className="flex h-full flex-col divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800 shadow-xl">
                                            <div className="h-0 flex-1 overflow-y-auto">
                                                <div className="bg-pink-700 px-4 py-6 sm:px-6">
                                                    <div className="flex items-center justify-between">
                                                        <Dialog.Title
                                                            className="text-base font-semibold leading-6 text-white">
                                                            Revert Dance
                                                        </Dialog.Title>
                                                        <div className="ml-3 flex h-7 items-center">
                                                            <button
                                                                type="button"
                                                                className="rounded-md bg-pink-700 text-pink-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                                onClick={() => {
                                                                    // setAdminCode(null);
                                                                    setUserCode(null);
                                                                    setRevertAmount(null);
                                                                    setPeopleFiltered(people);
                                                                    setSelectedDancerId(null);
                                                                    setSelectedDancerCode(null);
                                                                    setSelectedDancerName(null);
                                                                    setErrorMessage(null);

                                                                    setVirtualTipz(null);

                                                                    setDancerDances(null);
                                                                    setSelectedDanceId(null);

                                                                    setRevertOpen(false);
                                                                }}
                                                            >
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex flex-1 flex-col justify-between">
                                                    <div className="divide-y divide-gray-200 dark:divide-gray-700 px-4 sm:px-6">
                                                        <div className="space-y-6 pb-5 pt-6">
                                                            {errorMessage && <LoginError errorMessage={errorMessage}/>}
                                                            {selectedDancerId ? <div>
                                                                    <label
                                                                        htmlFor="project-name"
                                                                        className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
                                                                    >
                                                                        Choose Dancer
                                                                    </label>

                                                                    <span
                                                                        className="inline-flex mt-1 items-center rounded-md bg-pink-50 dark:bg-pink-950/40 px-2 py-1 text-sm font-bold text-gray-900 dark:text-pink-200 ring-1 ring-inset ring-pink-700/10 dark:ring-pink-800">
                                                                    {selectedDancerName}
                                                            </span>

                                                                    <div className="text-sm">
                                                                        <button
                                                                            className="font-medium mt-1 text-pink-500 cursor-pointer hover:text-pink-800"
                                                                            onClick={() => {
                                                                                setSelectedDancerId(null);
                                                                                setSelectedDancerCode(null);
                                                                                setSelectedDancerName(null);

                                                                                setDancerDances(null);
                                                                                setSelectedDanceId(null);
                                                                            }}
                                                                        >
                                                                            Choose a different dancer.
                                                                        </button>
                                                                    </div>

                                                                </div> :
                                                                <div>
                                                                    <label
                                                                        htmlFor="project-name"
                                                                        className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
                                                                    >
                                                                        Choose Dancer
                                                                    </label>
                                                                    <div className="relative mt-2 rounded-md shadow-sm">
                                                                        <div
                                                                            className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                                                            <UsersIcon className="h-5 w-5 text-gray-400 dark:text-gray-500"
                                                                                       aria-hidden="true"/>
                                                                        </div>
                                                                        <input
                                                                            type="text"
                                                                            name="search"
                                                                            className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 dark:text-gray-100 dark:bg-gray-800 ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                                                            placeholder="Search"
                                                                            onChange={(event) => {
                                                                                if (event.target.value && event.target.value.length > 0) {
                                                                                    let filteredPeople = people.filter(function (dancer) {
                                                                                        return dancer.name.substring(0, event.target.value.length).toLowerCase() === event.target.value.toLowerCase();
                                                                                    });
                                                                                    setPeopleFiltered(filteredPeople);
                                                                                } else {
                                                                                    setPeopleFiltered(people);
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="mt-6 flow-root">
                                                                        {!people && <DancerListSkeleton/>}
                                                                        <ul role="list"
                                                                            className="divide-y divide-gray-200 dark:divide-gray-700">
                                                                            {people && people.length === 0 &&
                                                                                <h3 className="mx-6">No Dancers are
                                                                                    setup
                                                                                    for this Venue.</h3>}
                                                                            {peopleFiltered && peopleFiltered.map((person) => (
                                                                                <li key={person.id}
                                                                                    className={selectedDancerId === person.id ? "py-4 bg-red-200" : "py-4"}>
                                                                                    <div
                                                                                        className="flex items-center space-x-4">
                                                                                        <div className="flex-shrink-0">
                                                                                            {/*<img className="h-8 w-8 rounded-full" src={person.imageUrl} alt="" />*/}
                                                                                        </div>
                                                                                        <div className="min-w-0 flex-1">
                                                                                            {selectedDancerId === person.id ?
                                                                                                <>
                                                                                                    <p className="truncate text-l font-bold text-gray-900 dark:text-gray-100">{person.name}</p>
                                                                                                    {/*<p className="truncate text-sm font-bold text-gray-500">ON STAGE</p>*/}
                                                                                                </>
                                                                                                :
                                                                                                <p className="truncate text-sm font-medium text-gray-900 dark:text-gray-100">{person.name}</p>
                                                                                            }
                                                                                        </div>
                                                                                        {selectedDancerId !== person.id &&
                                                                                            <div>
                                                                                                <button
                                                                                                    //disabled={isSwitchingGirls}
                                                                                                    className="inline-flex items-center rounded-full bg-white dark:bg-gray-800 px-2.5 py-1 text-xs font-semibold text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800"
                                                                                                    onClick={() => {
                                                                                                        //setIsSwitchingGirls(true);
                                                                                                        //switchGirl(venueId, person.id, switchGirlSuccess, switchGirlError);
                                                                                                        setSelectedDancerId(person.id);
                                                                                                        setSelectedDancerCode(person.dancerCode);
                                                                                                        setSelectedDancerName(person.name);
                                                                                                        setSelectedDanceId(null);
                                                                                                    }}
                                                                                                >
                                                                                                    Choose
                                                                                                </button>
                                                                                            </div>}
                                                                                    </div>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {adminCodeFeatureFlag && <div>
                                                                <label
                                                                    htmlFor="project-name"
                                                                    className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
                                                                >
                                                                    Admin Code
                                                                </label>
                                                                <div className="mt-2">
                                                                    <input
                                                                        type="text"
                                                                        name="adminCode"
                                                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 dark:bg-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                                                        onChange={(event) => {
                                                                            setAdminCode(event.target.value);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>}
                                                            <div>
                                                                {dancerDances && <label
                                                                    htmlFor="project-name"
                                                                    className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100"
                                                                >
                                                                    Dances
                                                                </label>}
                                                                {dancerDances && dancerDances.length === 0 && "No Dances"}
                                                                <ul role="list"
                                                                    className="grid grid-cols-1 gap-6 sm:grid-cols-1 lg:grid-cols-1">
                                                                    {dancerDances && dancerDances.map((theDance) => (
                                                                        <li key={theDance.id}
                                                                            className="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow">
                                                                            <div
                                                                                className="flex w-full items-center justify-between space-x-6 p-6">
                                                                                <div className="flex-1">
                                                                                    <div
                                                                                        className="flex items-center space-x-3">
                                                                                        <h3 className="truncate text-sm font-medium text-gray-900">{theDance.packageName}</h3>
                                                                                        <span
                                                                                            className="inline-flex flex-shrink-0 items-center rounded-full bg-pink-50 px-1.5 py-0.5 text-xs font-medium text-pink-700 ring-1 ring-inset ring-pink-600/20">
                  {theDance.vtAmount} VT
                </span>
                                                                                    </div>
                                                                                    <p className="mt-1 text-sm text-gray-500">This
                                                                                        will only revert from the
                                                                                        Dancer, the Customer must be
                                                                                        refunded in cash.</p>
                                                                                </div>
                                                                                {/*<img*/}
                                                                                {/*    className="h-10 w-10 flex-shrink-0 rounded-full bg-gray-300"*/}
                                                                                {/*    src={person.imageUrl} alt=""/>*/}
                                                                            </div>
                                                                            <div>
                                                                                <div
                                                                                    className="-mt-px flex divide-x divide-gray-200">
                                                                                    <div
                                                                                        className="flex w-0 flex-1 text-red-600 underline">
                                                                                        <span
                                                                                            className="relative cursor-pointer -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold"
                                                                                            onClick={() => {
                                                                                                if (!selectedDancerId || selectedDancerId.trim() === "") {
                                                                                                    setErrorMessage("There was a problem reverting the VT from the Dancer. Please try again.");
                                                                                                    return;
                                                                                                }
                                                                                                setSelectedDanceId(theDance.id);
                                                                                                setErrorMessage(null);
                                                                                                setConfirmRevertOpen(true);
                                                                                            }}
                                                                                        >
                                                                                            <ArrowPathIcon
                                                                                                className="h-5 w-5 text-gray-400"
                                                                                                aria-hidden="true"/>
                                                                                            Revert
                                                                                        </span>
                                                                                    </div>
                                                                                    {/*<div*/}
                                                                                    {/*    className="-ml-px flex w-0 flex-1">*/}
                                                                                    {/*    <a*/}
                                                                                    {/*        href={`tel:${person.telephone}`}*/}
                                                                                    {/*        className="relative inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-br-lg border border-transparent py-4 text-sm font-semibold text-gray-900"*/}
                                                                                    {/*    >*/}
                                                                                    {/*        <PhoneIcon*/}
                                                                                    {/*            className="h-5 w-5 text-gray-400"*/}
                                                                                    {/*            aria-hidden="true"/>*/}
                                                                                    {/*        Call*/}
                                                                                    {/*    </a>*/}
                                                                                    {/*</div>*/}
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div className="pb-6 pt-4">
                                                            <div className="flex text-sm">
                                                                <div
                                                                    className="group inline-flex items-center font-medium text-pink-600 hover:text-pink-900"
                                                                >

                                                                </div>
                                                            </div>
                                                            <div className="mt-4 flex text-sm">

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white dark:bg-gray-800 px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800"
                                                    onClick={() => {
                                                        // setAdminCode(null);
                                                        setUserCode(null);
                                                        setPeopleFiltered(people);
                                                        setSelectedDancerId(null);
                                                        setSelectedDancerCode(null);
                                                        setSelectedDancerName(null);
                                                        setErrorMessage(null);

                                                        setVirtualTipz(null);

                                                        setDancerDances(null);
                                                        setSelectedDanceId(null);

                                                        setRevertAmount(null);
                                                        setRevertOpen(false)
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                                {/*<button*/}
                                                {/*    className="ml-4 inline-flex justify-center rounded-md bg-pink-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"*/}
                                                {/*    onClick={() => {*/}
                                                {/*        if (!userCode || userCode.trim() === "" || !adminCode || adminCode.trim() === "") {*/}
                                                {/*            setErrorMessage("There was a problem reverting the Dance. Please verify Internet Connection and try again.");*/}
                                                {/*            return;*/}
                                                {/*        }*/}
                                                {/*        if (isNaN(revertAmount) || revertAmount <= 0) {*/}
                                                {/*            setErrorMessage("Revert amount must be greater than 0.");*/}
                                                {/*            return;*/}
                                                {/*        }*/}
                                                {/*        setErrorMessage(null);*/}
                                                {/*        setConfirmRevertOpen(true);*/}
                                                {/*    }}*/}
                                                {/*>*/}
                                                {/*    Revert VT from User*/}
                                                {/*</button>*/}
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

            <Transition.Root show={openConfirmRevert} as={Fragment}>
                <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef}
                        onClose={setConfirmRevertOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                        <div
                            className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel
                                    className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                        <div className="sm:flex sm:items-start">
                                            <div
                                                className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                                <ExclamationTriangleIcon className="h-6 w-6 text-red-600"
                                                                         aria-hidden="true"/>
                                            </div>
                                            <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                                <Dialog.Title as="h3"
                                                              className="text-base font-semibold leading-6 text-gray-900">
                                                    Revert VT
                                                </Dialog.Title>
                                                <div className="mt-2">
                                                    <p className="text-sm text-gray-500">
                                                        Are you sure you want revert this dance from this dancer?
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                        <button
                                            disabled={isSubmitting}
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                            onClick={() => {
                                                revertDance(venueId, selectedDancerId, selectedDanceId, adminCode, submitRevertSuccess, submitRevertError, getAccessTokenSilently);
                                                setIsSubmitting(true);
                                            }}
                                        >
                                            Revert {isSubmitting &&
                                            <CircularProgress color="inherit" size={20}/>}
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                            onClick={() => setConfirmRevertOpen(false)}
                                            ref={cancelButtonRef}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

            {/* Global notification live region, render this permanently at the end of the document */}
            <div
                aria-live="assertive"
                className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
            >
                <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                    {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                    <Transition
                        show={show}
                        as={Fragment}
                        enter="transform ease-out duration-300 transition"
                        enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                        enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div
                            className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5">
                            <div className="p-4">
                                <div className="flex items-start">
                                    <div className="flex-shrink-0">
                                        <CheckCircleIcon className="h-6 w-6 text-green-600" aria-hidden="true"/>
                                    </div>
                                    <div className="ml-3 w-0 flex-1 pt-0.5">
                                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">Successfully sold!</p>
                                        {/*<p className="mt-1 text-sm text-gray-500">{selectedSize && selectedSize.virtualTips} VirtualTipz</p>*/}
                                    </div>
                                    <div className="ml-4 flex flex-shrink-0">
                                        <button
                                            type="button"
                                            className="inline-flex rounded-md bg-white dark:bg-gray-800 text-gray-400 dark:text-gray-500 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                            onClick={() => {
                                                setShow(false);
                                            }}
                                        >
                                            <span className="sr-only">Close</span>
                                            <XMarkIcon className="h-5 w-5" aria-hidden="true"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition>
                </div>
            </div>

            {/* Global notification live region, render this permanently at the end of the document */}
            <div
                aria-live="assertive"
                className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
            >
                <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                    {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                    <Transition
                        show={showError}
                        as={Fragment}
                        enter="transform ease-out duration-300 transition"
                        enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                        enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div
                            className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5">
                            <div className="p-4">
                                <div className="flex items-start">
                                    <div className="flex-shrink-0">
                                        <CheckCircleIcon className="h-6 w-6 text-red-600" aria-hidden="true"/>
                                    </div>
                                    <div className="ml-3 w-0 flex-1 pt-0.5">
                                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{showErrorMessage}</p>
                                        {/*<p className="mt-1 text-sm text-gray-500">{selectedSize && selectedSize.virtualTips} VirtualTipz</p>*/}
                                    </div>
                                    <div className="ml-4 flex flex-shrink-0">
                                        <button
                                            type="button"
                                            className="inline-flex rounded-md bg-white dark:bg-gray-800 text-gray-400 dark:text-gray-500 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                            onClick={() => {
                                                setShowError(false);
                                                setErrorMessage(false);
                                            }}
                                        >
                                            <span className="sr-only">Close</span>
                                            <XMarkIcon className="h-5 w-5" aria-hidden="true"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition>
                </div>
            </div>
        </>
    )
}
